/** Seconds the applicant gets to answer each question. */
export const ANSWER_TIME = 300;

/**
 * The interview has no exam id of its own: this stands in for one, naming the folder
 * that both the KYC photo and every recorded answer are filed under.
 */
export const INTERVIEW_EXAM_ID = 'interview';

/** `pre` selects what the interview endpoint returns: `0` the summary, `n` question n. */
export const INTERVIEW_SUMMARY = 0;

export const ERROR_MESSAGE = 'An error occured, please try again.';

export const MEDIA_DENIED_MESSAGE = 'Please enable camera and microphone access to continue.';
